import { useEffect } from 'react';
import useAddMusicShortcut from './useAddMusicShortcut';

/** On a fresh page load (e.g. leaving first-run setup) move focus into the main region instead of leaving it on <body>. */
export function useFocusMainOnEntry() {
  useEffect(() => {
    const active = document.activeElement;
    if (active && active !== document.body) return;
    document.getElementById('maestro-scroll-container')?.focus({ preventScroll: true });
  }, []);
}

/** Keyboard / screen-reader entry points mounted once in AppLayout: Ctrl/Cmd+O Add Music, initial focus. */
export default function useKeyboardEntryPoints(nav) {
  useAddMusicShortcut(nav);
  useFocusMainOnEntry();
}
